import { LOGIN_ACTIONS } from "../constants/action-types";

const initialState = {
  token: null,
  user: {},
  message: {},
  status: false,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_ACTIONS.TOKEN_LOADING:
      return Object.assign({}, state, {
        token: null,
        user: {},
        message: "",
        status: false,
      });
    case LOGIN_ACTIONS.TOKEN_LOADED:
      return Object.assign({}, state, {
        token: action.payload.token,
        user: action.payload.user,
        message: "",
        status: true,
      });
    case LOGIN_ACTIONS.TOKEN_ERROR:
      return Object.assign({}, state, {
        token: null,
        user: {},
        message: action.payload.message,
        status: false,
      });
    case LOGIN_ACTIONS.LOGOUT:
      return Object.assign({}, state, {
        token: null,
        user: {},
        message: "",
        status: false,
      });

    default:
      return state;
  }
};

export default loginReducer;
